import samsungcase from '../../assets/muvtech/Muvdata/SamsungCases/Armour-Snap-s25-s25-ultre.png';

const samsungcaseData = [
  {
    id: 1,
    type: 'samsungcase',
    title: 'ARMOUR SNAP',
    compatibleModels: 'Samsung S25, S25 Ultra',
    price: 1999,
    specs: [
      'Dual-layer clear TPU',
      '360° Protection',
      'Camera protection',
      '8ft Drop Tested',
    ],
    image: [samsungcase],
  },
];

export default samsungcaseData;
